import * as axios from "axios";
import {AppCtx} from "../../ioc/ApplicationContext";
import {injectable} from "inversify";

export const HTTP_SERVICE_NAME = "httpService";


export interface HttpService {
    doGet<T>(path: string): Promise<T>;

    doPost<E, T>(path: string, entity: E): Promise<T>;

    doDelete(path: String): Promise<{}>;

}

@injectable()
export class HttpServiceImpl implements HttpService {

    axios: axios.AxiosInstance;
    private baseUrl: string;

    constructor() {
        this.baseUrl = contextPath + "/rest";
        this.axios = axios.create({
            responseType: 'json',
            headers: {'Content-Type': 'application/json'}
        });
    }

    handleError(path: string, response: axios.Response, reject) {
        if (path.indexOf("dashboard-user/login") != -1 || path.indexOf("dashboard-user/info") != -1) {
            console.log("Skipping error handling on resources ", path);
            reject({message: "Not logged in", status: response.status});
            return;
        }
        console.log("Error for path " + path + " with status " + response.status, response);
        var userActions = AppCtx.getUserActions();
        if (response.status == 401) {
            userActions.getUserInfo(false);
        }
        else if (response.status == 403) {
            reject({message: "Access denied", status: response.status});
        } else if (response.headers && response.headers["content-type"] == "application/json") {
            reject({message: response.data.message, status: response.status})
        } else if (response.status >= 500 && response.status < 600) {
            reject({
                message: "Internal server error, if this persist please contact support. ",
                status: response.status
            });
        } else {
            reject({message: "Error with status " + response.status, status: response.status});
        }


    }

    getConfig(): any {
        var state = AppCtx.getUserStore().getState();
        return {withCredentials: true, headers: {"X-Operator-Override": state.activeOperator}}
    }

    doGet<T>(path: string): Promise<T> {
        var promise = new Promise<T>((resolve, reject) => {
            this.axios.get(this.baseUrl + path, this.getConfig()).then((result: axios.Response) => {
                console.log("http get result for path " + path, result);
                var data = (<T>(result.data));
                resolve(data);
            }).catch((error) => {
                this.handleError(path, error, reject);

            });
        });
        return promise;

    }

    doPost<E, T>(path: string, entity: E): Promise<T> {
        var promise = new Promise<T>((resolve, reject) => {
            this.axios.post(this.baseUrl + path, entity, this.getConfig()).then((result: axios.Response) => {
                console.log("http post result for path " + path, result);
                var data = (<T>(result.data));
                resolve(data);
            }).catch((error) => {
                this.handleError(path, error, reject);
            });
        });
        return promise;
    }

    doDelete(path: string): Promise<{}> {
        var promise = new Promise<{}>((resolve, reject) => {
            this.axios.delete(this.baseUrl + path, this.getConfig()).then((result: axios.Response) => {
                resolve();
            }).catch((error) => {
                this.handleError(path, error, reject);
            });
        });
        return promise;
    }

}


// WEBPACK FOOTER //
// ./src/app/service/http/HttpService.ts